__turbopack_context__.v({
  "back": "Header-module-scss-module__kRgxYq__back",
  "backFromSearchPanel": "Header-module-scss-module__kRgxYq__backFromSearchPanel",
  "desktopRoot": "Header-module-scss-module__kRgxYq__desktopRoot",
  "desktopTransitionLogoWrapper": "Header-module-scss-module__kRgxYq__desktopTransitionLogoWrapper",
  "fade-in": "Header-module-scss-module__kRgxYq__fade-in",
  "fade-out": "Header-module-scss-module__kRgxYq__fade-out",
  "hasArrow": "Header-module-scss-module__kRgxYq__hasArrow",
  "hasChevron": "Header-module-scss-module__kRgxYq__hasChevron",
  "header": "Header-module-scss-module__kRgxYq__header",
  "headerContainer": "Header-module-scss-module__kRgxYq__headerContainer",
  "inner": "Header-module-scss-module__kRgxYq__inner",
  "isActive": "Header-module-scss-module__kRgxYq__isActive",
  "isHidden": "Header-module-scss-module__kRgxYq__isHidden",
  "isLanding": "Header-module-scss-module__kRgxYq__isLanding",
  "isMobileSearchOpen": "Header-module-scss-module__kRgxYq__isMobileSearchOpen",
  "leftLinks": "Header-module-scss-module__kRgxYq__leftLinks",
  "linkInner": "Header-module-scss-module__kRgxYq__linkInner",
  "linkLarge": "Header-module-scss-module__kRgxYq__linkLarge",
  "linkSmall": "Header-module-scss-module__kRgxYq__linkSmall",
  "linksWrapper": "Header-module-scss-module__kRgxYq__linksWrapper",
  "logo": "Header-module-scss-module__kRgxYq__logo",
  "logoBg": "Header-module-scss-module__kRgxYq__logoBg",
  "logoContainer": "Header-module-scss-module__kRgxYq__logoContainer",
  "logoSvg": "Header-module-scss-module__kRgxYq__logoSvg",
  "menuOpen": "Header-module-scss-module__kRgxYq__menuOpen",
  "mobileLogoWrapper": "Header-module-scss-module__kRgxYq__mobileLogoWrapper",
  "mobileLogoWrapper--backFromSubPanel": "Header-module-scss-module__kRgxYq__mobileLogoWrapper--backFromSubPanel",
  "mobileLogoWrapper--open": "Header-module-scss-module__kRgxYq__mobileLogoWrapper--open",
  "mobileLogoWrapper--subPanelOpen": "Header-module-scss-module__kRgxYq__mobileLogoWrapper--subPanelOpen",
  "mobileLogoWrapperTop": "Header-module-scss-module__kRgxYq__mobileLogoWrapperTop",
  "mobileLogoWrapperTop--backFromSubPanel": "Header-module-scss-module__kRgxYq__mobileLogoWrapperTop--backFromSubPanel",
  "mobileLogoWrapperTop--subPanelOpen": "Header-module-scss-module__kRgxYq__mobileLogoWrapperTop--subPanelOpen",
  "mobileRoot": "Header-module-scss-module__kRgxYq__mobileRoot",
  "mobileSearchBarBack": "Header-module-scss-module__kRgxYq__mobileSearchBarBack",
  "mobileSearchContainer": "Header-module-scss-module__kRgxYq__mobileSearchContainer",
  "mobileSubPanel": "Header-module-scss-module__kRgxYq__mobileSubPanel",
  "mobileSubPanel--backFromSubSub": "Header-module-scss-module__kRgxYq__mobileSubPanel--backFromSubSub",
  "mobileSubPanel--subSubOpen": "Header-module-scss-module__kRgxYq__mobileSubPanel--subSubOpen",
  "mobileSubPanelClose": "Header-module-scss-module__kRgxYq__mobileSubPanelClose",
  "mobileSubPanelNav": "Header-module-scss-module__kRgxYq__mobileSubPanelNav",
  "mobileSubSubPanel": "Header-module-scss-module__kRgxYq__mobileSubSubPanel",
  "nav": "Header-module-scss-module__kRgxYq__nav",
  "nav--open": "Header-module-scss-module__kRgxYq__nav--open",
  "nav--subPanelOpen": "Header-module-scss-module__kRgxYq__nav--subPanelOpen",
  "nav--subSubPanelOpen": "Header-module-scss-module__kRgxYq__nav--subSubPanelOpen",
  "navItem": "Header-module-scss-module__kRgxYq__navItem",
  "popularSearchesDesktopMobileInstance": "Header-module-scss-module__kRgxYq__popularSearchesDesktopMobileInstance",
  "rightLinks": "Header-module-scss-module__kRgxYq__rightLinks",
  "searchBarDesktop": "Header-module-scss-module__kRgxYq__searchBarDesktop",
  "searchBarMobile": "Header-module-scss-module__kRgxYq__searchBarMobile",
  "subNav": "Header-module-scss-module__kRgxYq__subNav",
  "subNavContainer": "Header-module-scss-module__kRgxYq__subNavContainer",
  "subNavDrawer": "Header-module-scss-module__kRgxYq__subNavDrawer",
  "up": "Header-module-scss-module__kRgxYq__up",
});
